export const en_other = {
  "btn-top": "top",
}

export const it_other = {
  "btn-top": "alto",
}